import { PersonalIdentifierDetails } from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsHelp,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type PassportGeneralFormType = PersonalIdentifierGeneralFormType;

export const PassportGeneralSection: PassportGeneralFormType = {
  ...commonGeneralFields,
};

export type PassportDto = Omit<PersonalIdentifierDetails, 'createdAt' | 'updatedAt'>;

export type PassportDetailsFormType = TDtoWrapper<PassportDto, PersonalIdentifierDetailsHelp>;

export const PassportDetailsSection: PassportDetailsFormType = {
  ...commonDetailsFields,
};

export const PassportLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const PassportFormSections = [
  PassportGeneralSection,
  PassportDetailsSection,
  PassportLegalizedCopiesSection,
];
